/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { state } from '../decorators/property.js';
import { createId } from '../utils/identity.js';
import { FirstFocusController } from '../controllers/first-focus.controller.js';
import { ClosableController } from '../controllers/closable.controller.js';
import { InlineFocusTrapController } from '../controllers/inline-focus-trap.controller.js';
export class CdsBaseFocusTrap extends LitElement {
    constructor() {
        super();
        this.firstFocusController = new FirstFocusController(this);
        this.closableController = new ClosableController(this);
        this.inlineFocusTrapController = new InlineFocusTrapController(this);
        this.demoMode = false;
        this.focusTrapId = createId();
    }
    render() {
        return html `<slot></slot>`;
    }
}
__decorate([
    state({ type: Boolean, reflect: true })
], CdsBaseFocusTrap.prototype, "demoMode", void 0);
__decorate([
    state({ type: String })
], CdsBaseFocusTrap.prototype, "focusTrapId", void 0);
